module.exports = __webpack_public_path__ + "static/media/bob.614c3202.png";